<!-- Dialog header -->
<div class="error-modal">
  <!-- Dialog content -->
  <div class="modal__cont">
    @if (imagePath) { 
      <img src="assets/{{ imagePath }}" width="256" height="256" alt="success" class="mt--200">
    }

    <div class="text-container">
      <h2 class="mt--150 engagement-error-dialog-header">{{ title }}</h2>
      @if (message) {
        <p class="mt--100 engagement-error-dialog-body" [innerHTML]="message | safeHtml"></p>
      }

      @if (errorCode) {
        <div class="mt--100 error-code">
          <!-- <div class="error-code__label">Error code</div> -->
          <div class="d-flex justify-content-center align-items-center gap-2">
            <code class="error-code__value text-color-primary-base" [attr.aria-label]="'Error code'">{{ errorCode }}</code>
            <button andButton color="secondary" type="button" (click)="copyErrorCode()">
              <aiwyn-icon name="copy" height="16" width="16" />
            </button>
          </div>
          @if (copied) {
            <div class="error-code__copied">Copied!</div>
          }
        </div>
      }
    </div>

    <div class="actions mt--150 grid-row justify-content-center">
      @if (shouldShowSupportLink) {
        @let version = version$ | async;
        <button andButton color="default" size="large" type="button" (click)="openSupportEmail(version)">
            Submit to Support
        </button>
      }

      <div class="grid-col grid-col--auto">
        <button
          andButton
          color="primary"
          size="large"
          (click)="onButtonClick()"
          type="button"
        >
          @if (buttonIcon) {
            <aiwyn-icon class="me-2" [name]="buttonIcon" height="16" width="16" />
          }

          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</div>
